import types from "../actions/types";

const initialState = {
  dienstregeling: undefined,
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.REQUEST_DIENSTREGELING:
      return Object.assign({}, state, {
        switchToDirectionId: undefined,
        alertsInfo: undefined,
        loading: true,
      });
    case types.REQUEST_DIENSTREGELING_FAILED:
      return initialState;
    case types.RECEIVED_DIENSTREGELING:
      return {
        ...initialState,
        dienstregeling: action.dienstregeling,
      };

    case types.SET_DIENSTREGELING_DIRECTION:
      return Object.assign({}, state, {
        switchToDirectionId: action.directionId,
      });

    case types.REQUEST_DIENSTREGELING_DISRUPTIONS:
      return Object.assign({}, state, {
        alertsInfo: undefined,
        loadingAlerts: true,
      });
    case types.RECEIVED_DIENSTREGELING_DISRUPTIONS:
      return Object.assign({}, state, {
        alertsInfo: action.alertsInfo,
        loadingAlerts: false,
      });
    case types.REQUEST_DIENSTREGELING_DISRUPTIONS_FAILED:
      return Object.assign({}, state, {
        alertsInfo: null,
        loadingAlerts: false,
      });
    case types.DIENSTREGELING_LOADING:
      return Object.assign({}, state, {
        loading: action.loading,
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dienstregeling.js